import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { fas } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';

import register, { unregister } from './registerServiceWorker';
import reportWebVitals from 'reportWebVitals';

library.add(fas);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

unregister();
reportWebVitals();